import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'

const mediaQuery = [{ screen: '(max-width: 767px)', width: '30vw' }]

export default function LianaMobile(): React.ReactElement {
  const { t } = useTranslation(['drill'])

  return (
    <ResponsiveImage
      alt={t('drill:imageAlt.beanStalkMobile')}
      fit="cover"
      height={2100}
      imageClassName="absolute -top-32 w-full max-w-none"
      loading="eager"
      mediaQuery={mediaQuery}
      srcKey="math-drills/index/beanstalk-mobile.png"
      width={315}
    />
  )
}
